import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '#/ui/utils/types';

export interface CardHeaderProps extends CommonProps<HTMLDivElement> {
  /**
   * The class name to apply to the root element.
   */
  className?: string;
  /**
   * The avatar to display.
   */
  avatar?: React.ReactNode;
  /**
   * The title to display.
   */
  title?: React.ReactNode;
  /**
   * The subtitle to display.
   */
  subtitle?: React.ReactNode;
  /**
   * The action to display.
   */
  action?: React.ReactNode;
}

function CardHeader({ className, title, subtitle, avatar, action, ...props }: CardHeaderProps) {
  return (
    <div
      {...props}
      className={twMerge(
        'gooey-card-header',
        'flex flex-row items-center px-4 pt-4 w-full relative',
        className
      )}
    >
      {avatar && <div className='gooey-card-header-avatar mr-4'>{avatar}</div>}
      {(title || subtitle) && (
        <div className='flex flex-col'>
          {title && (
            <div
              className={twMerge('gooey-card-header-title text-2xl text-primary-contrast mb-0.5')}
            >
              {title}
            </div>
          )}
          {subtitle && (
            <div className={twMerge('gooey-card-header-subtitle text-md text-content-secondary')}>
              {subtitle}
            </div>
          )}
        </div>
      )}
      <div className='grow' />
      {action && <div className={twMerge('gooey-card-header-action')}>{action}</div>}
    </div>
  );
}
CardHeader.displayName = 'GooeyCardHeader';

export default CardHeader;

// @todo fix text-content-secondary
